const CashbackActionType = {
  CREATE_CASH_BACK: 'CREATE_CASH_BACK',

  GET_CASH_BACK: 'GET_CASH_BACK',
  SAVE_CASH_BACK: 'SAVE_CASH_BACK',
  RESET_CASH_BACK: 'RESET_CASH_BACK',
  EDIT_CASH_BACK: 'EDIT_CASH_BACK',
};

export default CashbackActionType;
